import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';
import Select from 'react-select';

export default class KuposSelectBox extends Component {
  static propTypes = {
    selectedOption: PropTypes.object,
    options: PropTypes.array,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    placeholder: PropTypes.string,
    icon: PropTypes.string,
    iconRight: PropTypes.string,
    hideArrow: PropTypes.bool,
    height: PropTypes.number,
    noPaddingLeft: PropTypes.bool,
    smallArrow: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    readonly: PropTypes.bool,
    showAll: PropTypes.bool,
    appType: PropTypes.string,
    selectType: PropTypes.string,
    t: PropTypes.func,
    fontSize: PropTypes.string,
    styleClass: PropTypes.string,
    selectRef: PropTypes.object,
    addCustomStyling: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      cursor: 0,
      options: this.props.options,
      showSuggestions: false,
    };
  }
  componentDidMount() {
    if (this.props.selectType && this.props.options && !this.optionsFull)
      this.optionsFull = this.props.options;
    this.setState({
      options: this.props.options,
    });
  }
  componentWillUpdate() {
    if (this.props.selectType && this.props.options && !this.optionsFull)
      this.optionsFull = this.props.options;
    if (this.optionsFull && !this.optionsLoaded) {
      this.setState({
        options: this.optionsFull.slice(0, 100),
      });
      this.optionsLoaded = true;
    }
    if (
      typeof this.textValue === 'undefined' &&
      this.props.selectedOption &&
      this.props.selectedOption.label
    ) {
      this.textValue = this.props.selectedOption.label;
      this.setState({ textValue: this.props.selectedOption.label });
    }
  }

  scrollIfNotInView = el => {
    // if (el) {
    //   if (CommonService.isElementInView(el)) {
    //     console.log('In the viewport!');
    //   } else {
    //     el.scrollIntoView(false);
    //   }
    // }
  };

  clearValue = () => {
    setTimeout(() => {
      this.setState({ textValue: undefined });
      this.onSelect(null);
    }, 300);
  };
  handleKeyDown(e) {
    try {
      const { cursor, options } = this.state;
      // arrow up/down button should select next/previous list element
      if (e.keyCode === 38 && cursor > 0) {
        this.setState(prevState => ({
          cursor: prevState.cursor - 1,
        }));
      } else if (e.keyCode === 40 && cursor < options.length) {
        this.setState(prevState => ({
          cursor: prevState.cursor + 1,
        }));
      } else if (e.keyCode === 13 && cursor > 0) {
        this.onSelect(this.state.options[cursor - 1]);
      }
      setTimeout(() => {
        var c = document.querySelector('.auto-suggestions .cursor');
        if (c) {
          // var topPos = c.offsetTop;
          // document.querySelector('.auto-suggestions').scrollTop = topPos;
        }
      }, 300);
    } catch (error) {
      console.log('Error caught---- handleKeyDown');
    }
  }

  gotoActive = () => {
    var act = document.querySelector('.auto-suggestions .active');
    if (act) {
      var topPos = act.offsetTop;
      document.querySelector('.auto-suggestions').scrollTop = topPos - 10;
    }
  };

  inputChange = ev => {
    console.log('change input');
    try {
      let val = ev.target.value;
      let ops =
        val && !this.props.showAll
          ? this.props.options &&
            this.props.options.filter(it => {
              return (
                CommonService.getStringWithoutAccent(it.label.toLowerCase()).indexOf(
                  CommonService.getStringWithoutAccent(val.toLowerCase()),
                ) >= 0
              );
            })
          : this.props.options;
      this.setState({
        options: ops,
        textValue: val,
      });
      if (this.el) {
        setTimeout(() => {
          this.scrollIfNotInView(this.el);
        }, 250);
      }

      if (this.props.selectType && this.optionsFull) {
        let selectOptions = this.optionsFull.filter(it => {
          return (
            it['label']
              .toLowerCase()
              .replace('ñ', 'n')
              .replace('á', 'a')
              .replace('é', 'e')
              .replace('ó', 'o')
              .replace('í', 'i')
              .replace('ú', 'u')
              .indexOf(val.toLowerCase()) > -1 ||
            it['label'].toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            it['label']
              .toLowerCase()
              .replace('n', 'ñ')
              .replace('a', 'á')
              .replace('e', 'é')
              .replace('o', 'ó')
              .replace('i', 'í')
              .replace('u', 'ú')
              .indexOf(val.toLowerCase()) >= 0
          );
        });
        // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
        this.setState({
          options:
            selectOptions && selectOptions.length
              ? selectOptions.slice(0, 100)
              : this.optionsFull.slice(0, 100),
        });
      }
      if (this.props.onInputChange) this.props.onInputChange(val);
    } catch (error) {
      console.log('error caught-----', error);
    }
  };

  onSelect = val => {
    // don't show options when it's disabled
    // if (!this.props.disabled) {

    this.setState({
      textValue:
        val && val.label && val.label.indexOf(':') < 0 ? this.props.t(val.label) : val && val.label,
      showSuggestions: false,
      cursor: 0,
    });
    this.props.onChange(val);
    // }
  };

  onFocus = (toggle = false) => {
    try {
      if (toggle === true) {
        this.setState({ showSuggestions: !this.state.showSuggestions });
      } else {
        this.setState({ showSuggestions: true });
      }
      setTimeout(() => {
        // var b = window.document.querySelector('.is-focused');
        if (this.el) {
          // var as = window.document.querySelector('.auto-suggestions');
          // // if(b && as)
          // // if(document.documentElement.clientHeight - b.getBoundingClientRect().bottom < as.clientHeight){
          //   // if(b.getBoundingClientRect().top > as.clientHeight || (b.getBoundingClientRect().top > document.documentElement.clientHeight - b.getBoundingClientRect().bottom)){
          //   //   as.className = 'auto-suggestions up font10'
          //   // }else{
          //     as.className = 'auto-suggestions font10'
          //   // }
          // // }
          setTimeout(() => {
            this.scrollIfNotInView(this.el);
          }, 250);
          this.gotoActive();
        }
      }, 300);
    } catch (error) {
      console.log('Error caught---', error);
    }
  };

  onBlur = () => {
    setTimeout(() => {
      this.setState({ showSuggestions: false, cursor: 0 });
    }, 250);
  };

  render() {
    // console.log(this.props, 'options------')
    return (
      <div
        className={
          this.props.addCustomStyling
            ? 'common-kupos-select-box-outer-new'
            : 'common-kupos-select-box-outer'
        }
        style={this.props.disabled ? { pointerEvents: 'none', opacity: 0.6 } : {}}
      >
        {this.props.reactSelect ? (
          <div className="react-selectbox">
            {this.props.icon ? (
              <img
                alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
                className={
                  this.props.addCustomStyling ? 'icon-size-new icon-left' : 'icon-size icon-left '
                }
                src={this.props.icon}
                style={this.props.error ? { marginTop: '-18px' } : null}
              />
            ) : null}

            <Select
              menuColor="green"
              ref={this.props.selectRef}
              value={this.props.selectedOption}
              onChange={this.props.onChange}
              onInputChange={this.props.onInputChange}
              options={this.props.options ? this.props.options : []}
              placeholder={this.props.placeholder}
            />
          </div>
        ) : (
          <div
            className={
              'common-kupos-select-box kupos-border flex-row ' +
              (!this.props.hideArrow ? 'drop-arrow ' : '') +
              (this.props.noPaddingLeft ? 'no-padding-left ' : '') +
              (this.props.error ? 'is-error ' : '') +
              (this.state.showSuggestions ? 'is-focused ' : '') +
              (this.props.styleClass ? this.props.styleClass : '')
            }
            style={{
              height: (this.props.height || 70) + 'px',
              marginTop: (this.props.marginTop || 0.1) + 'px',
              background: this.props.noOptions ? '#efefef' : '#fff',
            }}
          >
            {this.props.icon ? (
              <img
                alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
                className="icon-size icon-left "
                src={this.props.icon}
              />
            ) : null}
            {/* <Select
            value={this.props.selectedOption}
            onChange={this.props.onChange}
            onInputChange={this.props.onInputChange}
            options={this.props.options}
            placeholder={this.props.placeholder}
          /> */}
            {this.props.readonly ? (
              <input
                ref={ref => (this.input = ref)}
                readOnly
                type="text"
                className={this.props.fontSize ? this.props.fontSize : 'font11'}
                onKeyDown={this.handleKeyDown}
                placeholder={this.props.placeholder}
                onClick={() => this.onFocus(true)}
                onBlur={this.onBlur}
                onChange={this.inputChange}
                value={
                  this.state.textValue && this.state.textValue.indexOf(':') < 0
                    ? this.props.t(this.state.textValue)
                    : this.state.textValue
                }
              />
            ) : (
              <input
                ref={ref => (this.input = ref)}
                type="text"
                className={this.props.fontSize ? this.props.fontSize : 'font11'}
                onKeyDown={this.handleKeyDown}
                placeholder={this.props.placeholder}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={this.inputChange}
                value={
                  this.state.textValue && this.state.textValue.indexOf(':') < 0
                    ? this.props.t(this.state.textValue)
                    : this.state.textValue
                }
              />
            )}
            {this.props.iconRight ? (
              <img
                alt={this.props.t('PROFILE.LOG_IN_HEADING')}
                className="icon-size icon-right "
                src={this.props.iconRight}
              />
            ) : null}
            {!this.props.hideArrow && !this.props.noOptions ? (
              <img
                className={
                  'icon-arrow pointer' +
                  (this.props.smallArrow ? 'small-arrow ' : '') +
                  (this.state.showSuggestions ? 'up-side-down ' : '')
                }
                src="/images/icons/icon-arrow.png"
                alt={this.props.t('PROFILE.LOG_IN_HEADING')}
                onClick={() => (this.props.readonly ? this.onFocus(true) : null)}
              />
            ) : null}
          </div>
        )}

        {this.props.error ? (
          <span className="error font9">{this.props.t(this.props.errorMessage)}</span>
        ) : null}

        {!this.props.disabled &&
        this.props.options &&
        this.state.showSuggestions &&
        this.state.options &&
        this.state.options.length > 1 ? (
          <div
            ref={el => {
              this.el = el;
            }}
            className={
              'auto-suggestions font10 scroll-style ' + (this.props.error ? 'error-shown' : '')
            }
          >
            {this.state.options &&
              this.state.options.map((val, key) => {
                return (
                  <a
                    className={
                      (this.props.selectedOption && val.value == this.props.selectedOption.value
                        ? 'active '
                        : '') + (this.state.cursor == key + 1 ? 'cursor' : '')
                    }
                    key={key}
                    onClick={() => !this.props.disabled && this.onSelect(val)}
                  >
                    {val.label && val.label.indexOf(':') < 0 ? this.props.t(val.label) : val.label}
                  </a>
                );
              })}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposSelectBox.js